import { makeVar, useReactiveVar } from "@apollo/client";

import { AutocompleteOptionType } from "../models/autocomplete";

export const selectedLocationVariable = makeVar<AutocompleteOptionType | null>(
  null
);

export const useSelectedLocation = () =>
  useReactiveVar(selectedLocationVariable);
